export const apiEndpoints = {
  reportStatusList: '/api/v1/reports/ts200status',
  exportXLSReport: '/api/v1/reports/ts200report',
  scheduleJobsDivision: '/api/v1/scheduledJobs/division',
  scheduleJobsUnitsByDivision: '/api/v1/scheduledJobs/unitsByDivision',
  scheduleJobsCrewType: '/api/v1/scheduledJobs/crewtype',
  scheduleJobsCrew: '/api/v1/scheduledJobs/crew',
  weeklyScheduleDrill: '/api/v1/scheduledJobs/crewWeeklyDetails',
  scheduledJobsViewWeeklyScheduleMX: '/api/v1/scheduledJobs/viewWeeklyScheduleMX',
  scheduledJobsGetmaximoLink: '/api/v1/scheduledJobs/getmaximoLink',
  userAccess: '/api/v1/user/userAccess',
  getContractor: '/api/v1/reports/getContractor',
  exportWeeklySchedule: '/api/v1/scheduledJobs/exportWeeklySchedule',
  varianceReport: '/api/v1/reports/varianceReport'
};
